import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "person-panel-list__count" }
const _hoisted_2 = { class: "person-panel-list__count-number" }
const _hoisted_3 = {
  key: 0,
  class: "person-panel-list__divider"
}
const _hoisted_4 = {
  key: 1,
  class: "person-panel-list__load-partial"
}

import {
	computed,
	onMounted,
	onUnmounted,
	ref,
	watch
} from "vue";
import throttle from "lodash/throttle";
import { clientsStore } from "@/store/clients";
import ClientsPanelListItem from "@/components/main/clients-panel/ClientsPanelListItem.vue";
import AppLoader from "@/components/common/AppLoader.vue";
import { mdiArrowUp } from "@quasar/extras/mdi-v7";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientsPanelList',
  props: {
    searchText: {}
  },
  emits: ["on-get-partial"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const props = __props

const store = clientsStore()
const $personPanelList = ref<HTMLDivElement | null>(null)
const isScrollBtnVisible = ref(false)

const isLoadingAll = computed(() => store.clientsLoading);
const isLoadingPartial = computed(() => store.clientsPartialLoading);
const clients = computed(() => store.getClients);

const scrollListTop = () => {
	$personPanelList.value?.scrollTo({
		top: 0
	});
}

const onScroll = throttle(() => {
	if (!$personPanelList.value) return

	if ($personPanelList.value.scrollTop + $personPanelList.value.offsetHeight > ($personPanelList.value.scrollHeight - 1000)) {
		if (!isLoadingPartial.value) {
			emit('on-get-partial')
		}
	}

	isScrollBtnVisible.value = $personPanelList.value.scrollTop > 300
}, 50)

onMounted(() => {
	$personPanelList.value?.addEventListener('scroll', onScroll)
})

onUnmounted(() => {
	$personPanelList.value?.removeEventListener('scroll', onScroll)
	onScroll.cancel()
})

watch(isLoadingAll, (newVal) => {
	if (newVal) {
		$personPanelList.value!.scrollTop = 0
	}
})

const loaderStyle = computed(() => ({
	'background-color': 'rgba(255, 255, 255, 0.5)'
}))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "person-panel-list",
    ref_key: "$personPanelList",
    ref: $personPanelList
  }, [
    (isLoadingAll.value)
      ? (_openBlock(), _createBlock(AppLoader, {
          key: 0,
          style: _normalizeStyle(loaderStyle.value)
        }, null, 8, ["style"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createTextVNode(" Найдено контактов: ")),
      _createElementVNode("div", _hoisted_2, _toDisplayString(clients.value?.length || 0), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clients.value, (client, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: client.Id
      }, [
        _createVNode(ClientsPanelListItem, {
          client: client,
          "search-text": props.searchText
        }, null, 8, ["client", "search-text"]),
        (index < clients.value.length - 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3))
          : _createCommentVNode("", true)
      ], 64))
    }), 128)),
    (isLoadingPartial.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(AppLoader)
        ]))
      : _createCommentVNode("", true),
    (isScrollBtnVisible.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "person-panel-list__scroll-top",
          onClick: scrollListTop
        }, [
          _createVNode(AppIcon, {
            class: "client-item__footer-options-btn",
            name: "arrow-up",
            width: "24px",
            color: "#fff",
            title: "Наверх"
          })
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})